import HeaderNone from './../../components/component/header/header_none.jsx';

import TravelAssistanceComponent from './../../components/component/travel_assistance/travel_assistance.jsx';


import FooterNone from './../../components/component/footer/footer_none.jsx'
import LaptopFooter from './../../components/component/footer/laptop_footer.jsx';



function TravelAssistance() {
    return (
            <main>
                <HeaderNone />
                <TravelAssistanceComponent />   

                <FooterNone />
                <LaptopFooter />

            </main>
    );
}

export default TravelAssistance;

